<template>
  <div v-if="pageCompleted">
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - 歌詞情報の登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area :index="2">
          歌詞情報の登録
        </release-step-area>
      </div>
      <lyrics-store-logos />
      <div class="single-column__inner">
        注意事項：
        <ul class="c-indent-list">
          <li class="c-indent-list__node">
            一度登録された歌詞を変更・削除することはできません。
          </li>
          <li class="c-indent-list__node">
            歌詞の掲載開始日を指定することはできません。
          </li>
          <li class="c-indent-list__node">
            JASRAC、NexToneに歌詞の管理委託されていない場合は、「著作権料の分配等の権利を放棄」に同意していただかないと、歌詞登録できません。
          </li>
          <li class="c-indent-list__node">
            今後歌詞の配信先ストアは自動的に追加・変更される場合があります。
          </li>
          <li class="c-indent-list__node">
            配信先ストアでの歌詞表示は、日本国内のみとなります。
          </li>
          <li class="c-indent-list__node">
            歌詞を登録しても配信ストア側の判断により、歌詞が登録されない場合があります。
          </li>
          <li class="c-indent-list__node">
            歌詞の表示タイミングは配信ストアにより異なりますので、最大1～2ヵ月程度かかる場合があります。
          </li>
          <li class="c-indent-list__node">
            登録された歌詞はプチリリ提供の配信ストアへも提供されます。<br />
            プチリリの提供する配信ストアは
            <a
              href="https://syncpower.jp/ja/partner"
              target="_blank"
              class="c-text-link">
              こちら
            </a>
          </li>
        </ul>
      </div>
      <br />
      <div
        class="confirm-checkbox-area">
        <div class="checkbox">
          <label>
            <input
              v-model="confirmed"
              type="checkbox">
            <div class="option-input"></div>歌詞登録の内容と注意事項を理解・同意しました
          </label>
        </div>
      </div>
      <div class="c-btn-wrap lyrics-btn">
        <div>
          <div class="lyrics-btn-card">
            <div
              class="release-status-area__item-edit-btn c-btn-release
                     c-btn-release--lyrics lyric-sync-button ">
              <span
                class="lyric-button-text">
                非同期歌詞入力</span>
            </div>
            <p>
              設定画面で歌詞を登録するだけで各ストアにて歌詞が表示されます。※ 非同期歌詞に対応していないストアもございます。
            </p>
            <img
              src="/images/asyncpic.png"
              alt="Asynsdsdc Pic"
              class="lyric-img">
          </div>
          <div class="sync-btn">
            <a
              class="c-btn"
              :class="{ 'c-btn--off': !confirmed }"
              href="#"
              @click.prevent="goSimpleForm">
              <span>非同期歌詞入力</span>
              <span class="c-btn__icon-arrow"></span>
            </a>
          </div>
        </div>
        <div>
          <div class="lyrics-btn-card">
            <div
              class="release-status-area__item-edit-btn c-btn-release
                     c-btn-release--lyrics lyric-sync-button">
              <span
                class="lyric-button-text">
                行同期歌詞入力</span>
            </div>
            <p>
              曲に合わせて歌詞が1行ずつ表示される形式です。
              設定画面で曲を流しながら歌詞の設定が必要となります。
              ※行同期に対応していないストアもございます。<a
                v-if="isBtoC"
                href="https://narasu.jp/client/faqs/138"
                target="_blank"
                class="c-text-link">
                詳細はこちら
              </a>
              <a
                v-else-if="!isBtoC"
                href="https://cmap.zula.jp/client/faqs/119"
                target="_blank"
                class="c-text-link">
                詳細はこちら
              </a>
            </p>
            <img
              src="/images/syncpic.png"
              alt="Asyncc Pic"
              class="lyric-img">
          </div>
          <div class="sync-btn">
            <a
              class="c-btn"
              :class="isPcMode ? 'c-btn--off' : (!confirmed ? 'c-btn--off' : '')"
              href="#"
              @click.prevent="goSyncForm">
              <span>行同期歌詞入力</span>
              <span class="c-btn__icon-arrow"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="lyric-back-btn">
        <a
          class="c-btn c-btn--back"
          href="#"
          @click.prevent="onReturnClicked">
          戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
      </div>
      <div
        v-show="isPcMode"
        class="pc-mode-info">
        行同期歌詞入力はパソコンからのみ設定可能です。<br>
        モバイル版は準備中となります。
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import ReleaseStepArea from '../StepArea'
import LyricsStoreLogos from './LyricsStoreLogos'

export default {
  name: 'ReleaseLyrics',
  components: {
    ReleaseStepArea,
    ReleaseTypeLabel,
    HeaderBar,
    LyricsStoreLogos,
  },
  data() {
    return {
      type: '',
      confirmed: false,
      pageCompleted: false,
      isPcMode: true,
    }
  },
  created() {
    // セッションストレージから一時保存されたデータを読み込み
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.type = release.type
    const { isBackMode, discIndex, trackIndex } = this.$route.params
    const { lyrics_type: lyricsType } = release.discs[discIndex].tracks[trackIndex]
    // PC Mode
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isPcMode = false
    }

    if (!isBackMode && !this.isPcMode) {
      if (lyricsType === 1) {
        this.goSimpleForm()
      } else if (lyricsType === 2) {
        this.goSyncForm()
      }
    }

    if (release.discs[discIndex].tracks[trackIndex].syncLyrics) {
      this.confirmed = true
    }

    this.pageCompleted = true
  },
  methods: {
    onReturnClicked() {
      const { discIndex, trackIndex } = this.$route.params
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2`,
        hash: `#disc${discIndex}-track${trackIndex}`,
      })
    },
    goSimpleForm() {
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-lyrics-simple`,
        params: {
          discIndex: this.$route.params.discIndex,
          trackIndex: this.$route.params.trackIndex,
        },
      })
    },
    goSyncForm() {
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-lyrics-sync`,
        params: {
          discIndex: this.$route.params.discIndex,
          trackIndex: this.$route.params.trackIndex,
        },
      })
    },
  },
}
</script>
<style scoped>
@media screen and (min-width: 895px) {
  .c-btn-wrap {
    margin: 0 20px 0 20px
  }

  .dsp-logo {
    margin: 20px auto 40px auto;
  }

  .dsp-logo IMG {
    max-width: 150px;
    min-height: 16px;
    max-height: 60px;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .dsp-logo .dsp-logo-dmusic {
    max-width: 120px;
    min-height:15px;
    margin-top:0;
  }
}
@media screen and (max-width: 895px) {
  .dsp-logo {
    margin: 10px auto 20px auto;
  }

  .dsp-logo IMG {
    max-width: 90px;
    min-height: 12px;
    max-height: 36px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
  .dsp-logo .dsp-logo-dmusic {
    max-width: 80px;
    min-height:12px;
  }
  .dsp-logo-wrap {
    display: none;
  }
}
</style>
